import { message } from '../../../Reducers/loading/actions';

// Action Types
export const PREVENTIEF_ONDERHOUD_LOADING = 'PREVENTIEF_ONDERHOUD_LOADING';
export const PREVENTIEF_ONDERHOUD_ERROR = 'PREVENTIEF_ONDERHOUD_ERROR';

// Onderhoudstaken
export const ONDERHOUDSTAKEN_SUCCESS = 'ONDERHOUDSTAKEN_SUCCESS';
export const ONDERHOUDSTAAK_DETAIL_SUCCESS = 'ONDERHOUDSTAAK_DETAIL_SUCCESS';
export const ONDERHOUDSTAAK_CREATE_SUCCESS = 'ONDERHOUDSTAAK_CREATE_SUCCESS';
export const ONDERHOUDSTAAK_UPDATE_SUCCESS = 'ONDERHOUDSTAAK_UPDATE_SUCCESS';
export const ONDERHOUDSTAAK_DELETE_SUCCESS = 'ONDERHOUDSTAAK_DELETE_SUCCESS';
export const ONDERHOUDSTAKEN_STATISTICS_SUCCESS = 'ONDERHOUDSTAKEN_STATISTICS_SUCCESS';

// Planning
export const PLANNING_SUCCESS = 'PLANNING_SUCCESS';
export const PLANNING_DETAIL_SUCCESS = 'PLANNING_DETAIL_SUCCESS';
export const PLANNING_CREATE_SUCCESS = 'PLANNING_CREATE_SUCCESS';
export const PLANNING_UPDATE_SUCCESS = 'PLANNING_UPDATE_SUCCESS';
export const PLANNING_DASHBOARD_SUCCESS = 'PLANNING_DASHBOARD_SUCCESS';

// Compliance
export const COMPLIANCE_SUCCESS = 'COMPLIANCE_SUCCESS';
export const COMPLIANCE_DETAIL_SUCCESS = 'COMPLIANCE_DETAIL_SUCCESS';
export const COMPLIANCE_CREATE_SUCCESS = 'COMPLIANCE_CREATE_SUCCESS';
export const COMPLIANCE_UPDATE_SUCCESS = 'COMPLIANCE_UPDATE_SUCCESS';
export const COMPLIANCE_DASHBOARD_SUCCESS = 'COMPLIANCE_DASHBOARD_SUCCESS';

// Voorraad
export const VOORRAAD_SUCCESS = 'VOORRAAD_SUCCESS';
export const VOORRAAD_DETAIL_SUCCESS = 'VOORRAAD_DETAIL_SUCCESS';
export const VOORRAAD_CREATE_SUCCESS = 'VOORRAAD_CREATE_SUCCESS';
export const VOORRAAD_UPDATE_SUCCESS = 'VOORRAAD_UPDATE_SUCCESS';
export const VOORRAAD_STATISTICS_SUCCESS = 'VOORRAAD_STATISTICS_SUCCESS';
export const VOORRAAD_LOW_STOCK_SUCCESS = 'VOORRAAD_LOW_STOCK_SUCCESS';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token
  };
};

// Helper function to handle response
function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

// ===========================================
// ONDERHOUDSTAKEN ACTIONS
// ===========================================

// Fetch all onderhoudstaken
export const fetchOnderhoudstaken = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/taken', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: ONDERHOUDSTAKEN_SUCCESS, payload: data.results });
      return { type: ONDERHOUDSTAKEN_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Fetch single onderhoudstaak
export const fetchOnderhoudstaak = (id) => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch(`/api/admin/preventief-onderhoud/taken/${id}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: ONDERHOUDSTAAK_DETAIL_SUCCESS, payload: data.results });
      return { type: ONDERHOUDSTAAK_DETAIL_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Create onderhoudstaak
export const createOnderhoudstaak = (taakData) => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/taken', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(taakData)
      });
      const data = await handleResponse(response);
      dispatch({ type: ONDERHOUDSTAAK_CREATE_SUCCESS, payload: data.results });
      dispatch(message('Onderhoudstaak succesvol aangemaakt', 'success'));
      return { type: ONDERHOUDSTAAK_CREATE_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Update onderhoudstaak
export const updateOnderhoudstaak = (id, taakData) => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch(`/api/admin/preventief-onderhoud/taken/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(taakData)
      });
      const data = await handleResponse(response);
      dispatch({ type: ONDERHOUDSTAAK_UPDATE_SUCCESS, payload: data.results });
      dispatch(message('Onderhoudstaak succesvol bijgewerkt', 'success'));
      return { type: ONDERHOUDSTAAK_UPDATE_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Delete onderhoudstaak
export const deleteOnderhoudstaak = (id) => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch(`/api/admin/preventief-onderhoud/taken/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: ONDERHOUDSTAAK_DELETE_SUCCESS, payload: id });
      dispatch(message('Onderhoudstaak succesvol verwijderd', 'success'));
      return { type: ONDERHOUDSTAAK_DELETE_SUCCESS, payload: id };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Fetch onderhoudstaken statistics
export const fetchOnderhoudstakenStatistics = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/taken/statistics/overview', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: ONDERHOUDSTAKEN_STATISTICS_SUCCESS, payload: data.results });
      return { type: ONDERHOUDSTAKEN_STATISTICS_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// ===========================================
// PLANNING ACTIONS
// ===========================================

// Fetch all planning
export const fetchPlanning = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/planning', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: PLANNING_SUCCESS, payload: data.results });
      return { type: PLANNING_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Fetch planning dashboard
export const fetchPlanningDashboard = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/planning/dashboard/overview', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: PLANNING_DASHBOARD_SUCCESS, payload: data.results });
      return { type: PLANNING_DASHBOARD_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// ===========================================
// COMPLIANCE ACTIONS
// ===========================================

// Fetch all compliance
export const fetchCompliance = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/compliance', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: COMPLIANCE_SUCCESS, payload: data.results });
      return { type: COMPLIANCE_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Fetch compliance dashboard
export const fetchComplianceDashboard = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/compliance/dashboard/overview', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: COMPLIANCE_DASHBOARD_SUCCESS, payload: data.results });
      return { type: COMPLIANCE_DASHBOARD_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// ===========================================
// VOORRAAD ACTIONS
// ===========================================

// Fetch all voorraad
export const fetchVoorraad = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/voorraad', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: VOORRAAD_SUCCESS, payload: data.results });
      return { type: VOORRAAD_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Fetch voorraad statistics
export const fetchVoorraadStatistics = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/voorraad/statistics/overview', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: VOORRAAD_STATISTICS_SUCCESS, payload: data.results });
      return { type: VOORRAAD_STATISTICS_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};

// Fetch low stock items
export const fetchLowStock = () => {
  return async (dispatch) => {
    dispatch({ type: PREVENTIEF_ONDERHOUD_LOADING });
    try {
      const response = await fetch('/api/admin/preventief-onderhoud/voorraad/low-stock/list', {
        method: 'GET',
        headers: getAuthHeaders()
      });
      const data = await handleResponse(response);
      dispatch({ type: VOORRAAD_LOW_STOCK_SUCCESS, payload: data.results });
      return { type: VOORRAAD_LOW_STOCK_SUCCESS, payload: data.results };
    } catch (error) {
      dispatch({ type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message });
      dispatch(message(error.message, 'error'));
      return { type: PREVENTIEF_ONDERHOUD_ERROR, payload: error.message };
    }
  };
};